import { Address } from '@dehaat/kisan-app-bl/models/AddressV2';
import useTranslation from 'next-translate/useTranslation';
import { SHRI_PROGRAM_USER_DETAILS } from '@/constants/common';
import useTriggerEvents from '@/hooks/useTriggerEvents';
import { ShriUserInLS } from '@/models/shriProgram';
import CustomEventTypes from '@/utils/analytics/customEventTypes';
// import { trackCustomEvent } from '@/utils/analytics/googleAnalytics'
import { getLocalStorageKey } from '@/utils/helper';
import InfoBadgeIcon from '../icons/InfoBadgeIcon';
import LocationAddressIcon from '../icons/LocationAddressIcon';
import PhoneIconInCart from '../icons/phoneIconInCart';
import SolidTriangle from '../icons/SolidTriangle';
import Paragraph, { VARIANT } from '../Paragraph';
import SubHeading, { VARIANT as SUB_HEADING } from '../SubHeading';
interface Props {
  address: Address;
  handleChangeAddress: VoidFunction;
  kycStatus: boolean | null;
  className?: string;
}
const AddressCard = ({
  address,
  handleChangeAddress,
  kycStatus,
  className = ''
}: Props) => {
  const {
    t
  } = useTranslation('cart');
  const {
    trackCustomEvent
  } = useTriggerEvents();
  const {
    street_address_1,
    street_address_2,
    block,
    district,
    state,
    pin_code,
    contact_number
  } = address;
  const fullDisplayAddress = `${street_address_2 ? `${street_address_1}, ${street_address_2}` : `${street_address_1}`}, ${block}, ${district}, ${state}, ${pin_code}`;
  const onChangeAddress = () => {
    trackCustomEvent(CustomEventTypes.CHANGE_ADDRESS);
    handleChangeAddress();
  };
  const isShriFlow = getLocalStorageKey<ShriUserInLS, null>(SHRI_PROGRAM_USER_DETAILS);
  const allowAddressChange = !isShriFlow || isShriFlow?.allowChangeAddress;
  return <div className={`bg-white px-4 pb-6 ${className}`} data-sentry-component="AddressCard" data-sentry-source-file="SelectedAddress.tsx">
      <article className="relative flex flex-col gap-2 bg-white p-3 border border-orange-fill-100 rounded-xl" data-testid="selectedAddress-card-article">
        <SolidTriangle width={16} height={8} className="top-[-8px] left-20 absolute" data-sentry-element="SolidTriangle" data-sentry-source-file="SelectedAddress.tsx" />
        <div className="flex justify-between">
          <SubHeading variant={SUB_HEADING.SMALL} ariaLevel={2} data-sentry-element="SubHeading" data-sentry-source-file="SelectedAddress.tsx">
            {t('delivery_address')}
          </SubHeading>
          {allowAddressChange && <button data-testid="change_address_btn" className="font-semibold text-primary-100 text-sm" onClick={onChangeAddress}>
              {t('change')}
            </button>}
        </div>
        <div className="flex gap-1">
          <LocationAddressIcon width={20} height={20} data-sentry-element="LocationAddressIcon" data-sentry-source-file="SelectedAddress.tsx" />
          <div className="gap-1 mt-[-4px]">
            <Paragraph variant={VARIANT.BIG} isHighlighted className="font-semibold text-md text-neutral-90" data-sentry-element="Paragraph" data-sentry-source-file="SelectedAddress.tsx">
              {address.contact_name || ''}
            </Paragraph>
            <Paragraph variant={VARIANT.MEDIUM} className="w-[90%] text-neutral-90 mt-1" data-sentry-element="Paragraph" data-sentry-source-file="SelectedAddress.tsx">
              {fullDisplayAddress}
            </Paragraph>
          </div>
        </div>
        <div className="flex items-center gap-1">
          <PhoneIconInCart width={20} height={20} data-sentry-element="PhoneIconInCart" data-sentry-source-file="SelectedAddress.tsx" />
          <Paragraph variant={VARIANT.MEDIUM} className="mt-[-4px] text-neutral-90" data-sentry-element="Paragraph" data-sentry-source-file="SelectedAddress.tsx">
            {contact_number}
          </Paragraph>
          {false ? <div className="flex items-center ml-[13.25px]">
              <InfoBadgeIcon className={`h-5 w-5 ${kycStatus ? 'fill-success-100' : 'fill-error-90'}`} />
              <Paragraph variant={VARIANT.SMALL} isHighlighted className="ml-[5.25px] text-neutral-80">
                {t(kycStatus ? 'cartInsurance:kyc_verified' : 'cartInsurance:kyc_pending')}
              </Paragraph>
            </div> : null}
        </div>
      </article>
    </div>;
};
export default AddressCard;